/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type HideAgentMcpServerRequestBody = {
  /**
   * The MCP server, as getMyConnections reports it.
   */
  mcpServerId: string;
};

/** @internal */
export type HideAgentMcpServerRequestBody$Outbound = {
  mcp_server_id: string;
};

/** @internal */
export const HideAgentMcpServerRequestBody$outboundSchema: z.ZodMiniType<
  HideAgentMcpServerRequestBody$Outbound,
  HideAgentMcpServerRequestBody
> = z.pipe(
  z.object({
    mcpServerId: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
    });
  }),
);

export function hideAgentMcpServerRequestBodyToJSON(
  hideAgentMcpServerRequestBody: HideAgentMcpServerRequestBody,
): string {
  return JSON.stringify(
    HideAgentMcpServerRequestBody$outboundSchema.parse(
      hideAgentMcpServerRequestBody,
    ),
  );
}
